import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const canActivateGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wenn der Benutzer nicht eingeloggt ist: direkt ablehnen
  if (!authService.isLoggedIn()) {
    router.navigate(['/login']);
    return of(false);
  }

  // Session prüfen
  return authService.checkSession().pipe(
    map((response) => {
      // Sitzung gültig
      if (response.status !== 401 && response.statusText !== 'Unauthorized') {
        return true;
      } else {
        authService.logout();
        router.navigate(['/login']);
        return false;
      }
    }),
    catchError(() => {
      authService.logout();
      router.navigate(['/login']);
      return of(false);
    })
  );
};